export const center_app_version = {"commit_sha": "b450f1b1"}
